let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3R6XQ"), load("u2Avf"), load("ixaXv")]).then(() => parcelRequire('diWiU'));